import React from 'react';

export const Hide = function (props) {
    let { show, children } = props;
    return <div style={show ? { display: 'contents' } : { display: 'none' }}>{children}</div>;
    // if (children === null || children === undefined) {
    //     return null;
    // }

    // // 单个子元素
    // if (React.isValidElement(children)) {
    //     return React.cloneElement(children, {
    //         style: {
    //             ...children.props.style,
    //             ...(show ? {} : { display: 'none' })
    //         }
    //     });
    // }

    // // 其他情况（如字符串、数字等）
    // return show ? children : null;
};
